<template>
  <vt-combo-select
    id="languageSelector"
    v-model="selectedUiLanguage"
    :allow-empty="false"
    :searchable="false"
    :options="uiLanguages"
    :option-height="20"
    :show-labels="false"
    track-by="id"
    label="name"
    name="name"
  />
</template>

<script>
import languageService from '@/api/resources/common/languageService'
import { loadLanguageAsync } from '@/shared/util/i18n.helper'

export default {
    name: 'VtLanguageSelector',
    data() {
        return {
            uiLanguages: [],
            selectedUiLanguage: null
        }
    },
    watch: {
        async selectedUiLanguage() {
            if (this.selectedUiLanguage) {
                this.$emit('loading-translations', true)
                await loadLanguageAsync(this.selectedUiLanguage.locale, this.selectedUiLanguage.id)
                this.$emit('loading-translations', false)
            }
        }
    },
    async mounted() {
        const response = await this.$_toCallSecure(languageService.findAllActiveAndUiEnabled())
        if (response) {
            this.uiLanguages = response

            this.selectedUiLanguage =
                this.uiLanguages.find(uiLanguage =>
                    uiLanguage.locale === this.$i18n.locale ?? uiLanguage.defaultLanguage)
        }
    }
}
</script>
